import { keepPreviousData, useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import ApiRoutes from "routing/ApiRoutes";
import { defaultOnError } from "util/conditional/onError";
const getUrl = (stats, security) => qualifyUrl(ApiRoutes.IndexSetsApiController.list(stats, security).url);
const fetchIndexSetsList = (stats, only_open) => fetch("GET", getUrl(stats, only_open)).then((response) => ({
  indexSetsCount: response.total,
  indexSets: response.index_sets,
  indexSetStats: response.stats
}));
const initialData = { indexSets: [], indexSetsCount: null, indexSetStats: null };
const useIndexSetsList = (stats = false, refetchInterval = false, only_open = false) => {
  const { data, refetch, isInitialLoading, isSuccess } = useQuery({
    queryKey: ["IndexSetsList", stats],
    queryFn: () => defaultOnError(
      fetchIndexSetsList(stats, only_open),
      "Loading index sets with list failed with status",
      "Could not load index sets list"
    ),
    placeholderData: keepPreviousData,
    refetchInterval
  });
  return {
    data: data != null ? data : initialData,
    refetch,
    isSuccess,
    isInitialLoading
  };
};
export default useIndexSetsList;
